<!--<ipos-sidebar></ipos-sidebar>-->
<article>
  <div class="header bg-white">
    <div class="container-fluid">
      <div class="header-body">
        <div class="row align-items-center py-3 mb-2">
          <div class="col-lg-6 col-5">
            <h3 style="justify-content: center;" class="h3 mb-0">Reconfigure Details</h3>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
              <ol class="breadcrumb breadcrumb-links breadcrumb-dark mt-2">
                <li class="breadcrumb-item">
                  <i class="fas fa-home"></i>
                </li>
                <li class="breadcrumb-item"><a routerLink="/dashboard">Dashboard</a></li>
                <li class="breadcrumb-item active" aria-current="page">
                  Reconfigure History
                </li>
              </ol>
            </nav>
          </div>
          <div class="col-lg-6 col-7 text-right">
            <app-search-bar (searchChange)="onSearchChanged($event)"
              placeholder="Search by Tid/Mid/Serialkey"></app-search-bar>

          </div>

        </div>
      </div>
    </div>
  </div>

  <!-- <h1 style="justify-content: flex; text-align: center; color: indianred;"> Support Details</h1> -->
  <div class="p-3">
    <button class="btn btn-neutral text-white mb-2" (click)="onBtnExport()" style="padding: 5px 10px !important;">Export Data
      <i class="fas fa-file-download text-white"></i> </button>
    <!-- <div class="col-sm-2" style="float: right;" >
        <select (change)="filterCompleted($event.target.value)" >
        <option *ngFor="let row of dropDownItems" [value]="row.name"  class="drop" >
          <span> {{ row.name }}</span>
        </option>
      </select>
     </div> -->
    <ag-grid-angular style=" height: 500px;" class="ag-theme-balham" [enableSorting]="true" [enableFilter]="true"
      [enableCellTextSelection]="true" [rowData]="rows2" [pagination]="true" [rowHeight]="40" [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef" [popupParent]="popupParent" (gridReady)="onGridReady($event)">
    </ag-grid-angular>

  </div>
</article>